module.exports = __webpack_public_path__ + "img/guandiantong.e4e8059b.png";